import clsx from 'clsx';
import { Squares2X2Icon } from '@heroicons/react/24/outline';
import { useContentWindow } from '../context/ContentWindowContext';
import { navActionButtonClass } from '../components/layout/navActionButton';

/** Content Studio launcher in the top navbar. */
export default function ContentTaskbar({ className }) {
  const { open, restore, openStudio, stepLabel: step } = useContentWindow();

  const handleClick = () => {
    if (open) restore();
    else openStudio();
  };

  const label =
    open && step && step !== 'Content Studio'
      ? step
      : 'Content Studio';

  const tooltip =
    open && step && step !== 'Content Studio'
      ? `Resume Content Studio · ${step}`
      : open
        ? 'Resume Content Studio'
        : 'Open Content Studio';

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={open ? 'Restore Content Studio' : 'Open Content Studio'}
      title={tooltip}
      className={clsx(navActionButtonClass({ active: open }), className)}
    >
      <Squares2X2Icon className="h-4 w-4 shrink-0 text-brand-600" strokeWidth={2} />
      <span className="truncate max-w-[9rem]">{label}</span>
    </button>
  );
}
